// API Configuration
const API_CONFIG = {
  // Base URL for backend API
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  
  // API endpoints
  ENDPOINTS: {
    // Auth endpoints
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    
    // Admin endpoints
    DASHBOARD: '/api/admin/dashboard',
    USERS: '/api/admin/users',
    ORDERS: '/api/admin/orders',
    TRANSACTIONS: '/api/admin/transactions',
    STOCKS: '/api/admin/stocks',
    ANALYTICS: '/api/admin/analytics',
    
    // Config endpoints
    CONFIG: '/api/admin/config',
    UPDATE_TOKEN: '/api/admin/config/update-token',
    RESTART: '/api/admin/restart',
    SERVER_STATUS: '/api/admin/server-status',
    
    // Transaction management
    TRANSACTION_STATUS: '/api/admin/transactions/:id/status',
    TRANSACTION_BULK: '/api/admin/transactions/bulk-action',
    TRANSACTION_ANALYTICS: '/api/admin/analytics/transactions'
  }
};

// Helper function to build full URL
export const buildUrl = (endpoint, params = {}) => {
  let url = `${API_CONFIG.BASE_URL}${endpoint}`;
  
  // Replace URL parameters (e.g., :id)
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  
  return url;
};

// Helper function to get auth headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// Export API config
export { API_CONFIG };
export default API_CONFIG;
